import React from "react";
import { Product } from "../../../types/productTypes";
import { useNavigate } from "react-router-dom";

interface SimilarProductCardProps {
    item: Product;
}

const SimilarProductCard = ({ item }: SimilarProductCardProps) => {
    const navigate = useNavigate();

    const handleCardClick = () => {
        if (item.id) {
            navigate(`/product-details/${item.category?.categoryId}/${item.title}/${item.id}`);
        }
    };

    return (
        <div 
            onClick={handleCardClick} 
            className="group cursor-pointer border border-gray-100 rounded-lg p-2 sm:p-3 bg-white hover:shadow-md transition-shadow duration-300 flex flex-col h-full gap-2"
        >
            {/* TOP SIDE: Dynamic Aspect-Square Image Container */}
            <div className='relative overflow-hidden aspect-square w-full bg-gray-50 flex items-center justify-center rounded-md border border-gray-100'>
                <img 
                    className='absolute inset-0 w-full h-full object-cover transition-transform duration-500 ease-in-out group-hover:scale-105' 
                    src={item.images?.[0] || "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTctl02UiSUqaJlEHt9du_AiYsMlg_Uq4t0eQ&s"} 
                    alt={item.title}
                />
            </div>
            
            {/* BOTTOM SIDE: Product Details */}
            <div className='flex flex-col justify-between flex-1 min-w-0 pt-0.5 gap-2'>
                <div className="space-y-0.5">
                    <h1 className="text-[9px] sm:text-[10px] text-gray-400 font-semibold uppercase tracking-wider truncate">
                        {item.seller?.businessDetails?.businessName || "Stamka Vendor"}
                    </h1>
                    <p className="text-gray-800 font-medium text-xs sm:text-sm line-clamp-2 leading-snug min-h-[1.0rem]">
                        {item.title}
                    </p>
                </div>
                
                {/* Price section formatted matching the main layout */}
                <div className='price flex flex-wrap items-center gap-1 text-[11px] sm:text-xs'>
                    <span className="font-semibold text-gray-900">
                        Ksh {item.sellingPrice.toLocaleString()}
                    </span>
                    
                    {item.mrpPrice > item.sellingPrice && (
                        <>
                            <span className="line-through text-gray-400 scale-90 origin-left">
                                Ksh {item.mrpPrice.toLocaleString()}
                            </span>
                            <span className="text-emerald-600 font-bold text-[9px] sm:text-[10px]">
                                {item.discountPercent}% OFF
                            </span>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SimilarProductCard;